var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-radios van-cell van-field",attrs:{"role":"button","tabindex":"0"}},[_c('div',{staticClass:"van-cell__title van-field__label tag-radios-label",style:({
    width: _vm.labelWidth
  })},[_c('span',[_vm._v(_vm._s(_vm.label))])]),_c('div',{staticClass:"van-cell__value van-field__value"},_vm._l((_vm.optionRows),function(row,i){return _c('div',{key:i,staticClass:"tag-radios-row",class:{
      left: _vm.inputAlign === 'left',
      right: _vm.inputAlign === 'right',
      center: _vm.inputAlign === 'center'
    }},_vm._l((row),function(radio){return _c('div',{key:radio.value,staticClass:"radio",class:{
          active: radio.value === _vm.value
        },on:{"click":function($event){return _vm.$emit('change', radio.value)}}},[_vm._v(" "+_vm._s(radio.text)+" ")])}),0)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }